import { render, staticRenderFns } from "./ProductCreateEdit.vue?vue&type=template&id=46d30dbb&scoped=true&"
import script from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreateEdit.vue?vue&type=style&index=0&id=46d30dbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d30dbb",
  null
  
)

export default component.exports